// forEach polyfill
if ( window.NodeList && !NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

const elementsToShow = document.querySelectorAll( '.animate' );
const header = document.getElementById('header');
const headerStickyWrap = document.getElementById('site_header_sticky_wrap');

const scrollProps = {
	'scrollStatus' 					: null,
	'scrollPercentage' 			: null,
	'scrollDirection'				: null,
	'windowY'								: null,
	'lastKnownY'						: null,
	'directionReversedAt' 	: null,
	'distanceSinceReverse' 	: null,
	'compressesAt'					: 400,
	'unsticksAt'						: 500,
	'directionThreshold'		: 80
};

let reducing = null;
let scroll = window.requestAnimationFrame; // || function( callback ){ window.setTimeout( callback, 1000/60 ); }


/**
 *
 *
 *
 */
const init = function() {

	setTimeout( () => {
		document.body.classList.add( 'enable-header-transitions' )
	}, 250 );

	loop();

};


/**
 *
 *
 *
 */
const loop = function() {

	updateScrollProps();

	if ( headerStickyWrap.classList.contains('js-compress-on-scroll') ) {
		compressOnScroll();
	}

	watchForAnimationItems();
	topWatch();

	scroll( loop );

};


const watchForAnimationItems = function() {

	elementsToShow.forEach( ( element ) => {
		const baseClass = 'animated';
		if ( isElementInViewport( element ) ) {
			if ( element.classList.contains( baseClass ) ) {
				return;
			}
			element.classList.add( baseClass );
		}
	});

}


const updateScrollProps = function() {

	updateWindowY();

}


const updateWindowY = function() {

	const supportPageOffset = window.pageXOffset !== undefined;
	const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	const windowY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

	scrollProps.windowY = windowY;

}


const compressOnScroll = function() {

	if ( scrollProps.windowY > scrollProps.compressesAt && !header.classList.contains( 'show-on-scroll' ) ) {

    headerStickyWrap.classList.add( 'ready-to-show' )

    reducing = setTimeout( () => {
      headerStickyWrap.classList.add( 'show-on-scroll' )
      reducing = null;
    }, 250 )

	} else if ( scrollProps.windowY < scrollProps.compressesAt - header.offsetHeight ) {

    reducing = null;
    headerStickyWrap.classList.remove( 'show-on-scroll' )
    headerStickyWrap.classList.remove( 'ready-to-show' )
	
  }

}


const topWatch = function() {

	if ( !header ) return;

	const className = 'is-at-top';

	if ( scrollProps.windowY === 0 ) {
		document.body.classList.add( className );
	} else {
		document.body.classList.remove( className );
	}

}


const isElementInViewport = ( el ) => {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};


const api = {
	init: init
};

export default api;